module.exports = __webpack_public_path__ + "img/lab1.0103097f.png";